import Vue from 'vue';
import $ from 'jquery';
import Hammer from 'hammerjs';
import template from './template.html';
import {lory} from 'lory.js';

export default Vue.component('modal', {
  template: template,
  data () {
    return {
      currentSlide: 0,
      slider: undefined,
      showSocials: false
    };
  },
  props: ['modal', 'isActive', 'closeModal'],
  watch: {
    isActive () {
      let $vm = this;
      setTimeout(function () {
        $vm.setupSlider();
      }, 1000);
    }
  },
  mounted () {
    let $vm = this;
    let hammertime = new Hammer(this.$el);
    hammertime.on('swiperight', function(ev) {
      if(ev.target.nodeName !== 'IMG') {
        $vm.closeThisModal();
      }
    });
    if(window.addthis && window.addthis.toolbox) {
      window.addthis.toolbox($(this.$el).find('.addthis_toolbox')[0]);
    }

  },
  methods: {
    slideTo (index) {
      this.slider.slideTo(index);
    },
    setupSlider () {
      let slider = $(this.$el).find('.js_slider')[0];
      let $vm = this;
      $vm.slider = lory(slider, {
        infinite: 1,
        enableMouseEvents: true
      });

      slider.addEventListener('after.lory.slide', function (currentSlide) {
        $vm.currentSlide = currentSlide.detail.currentSlide - 1;
      });
    },
    closeThisModal () {
      this.closeModal();
    }
  },
  computed: {
    categoryClass () {
      return this.modal.category.toString().split('&')[0].trim();
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/modal/main.js